import { GasCan } from "@phosphor-icons/react";
import { renderToStaticMarkup } from "react-dom/server";
import type { GasStationResponseDto } from "@pro-sto/api-client";
import { STATUS_MARKER_COLORS } from "./constants";

const MARKER_OUTER_SIZE = 36;
const MARKER_ANCHOR = MARKER_OUTER_SIZE / 2;

const GAS_CAN_ICON_HTML = renderToStaticMarkup(
  <GasCan weight="fill" color="#FFFFFF" size={20} aria-hidden />,
);

export function createGasStationMarkerHtml(
  status: GasStationResponseDto["status"],
  isSelected = false,
): string {
  const color = STATUS_MARKER_COLORS[status];
  const selectedClass = isSelected ? " gs-map-marker__wrapper--selected" : "";

  return `
    <div class="gs-map-marker__wrapper${selectedClass}">
      <div class="gs-map-marker__ring">
        <div class="gs-map-marker__circle" style="background-color:${color}">
          ${GAS_CAN_ICON_HTML}
        </div>
      </div>
    </div>
  `;
}

export function createGasStationMarkerIcon(
  L: {
    divIcon(options: Record<string, unknown>): unknown;
  },
  status: GasStationResponseDto["status"],
  isSelected = false,
) {
  return L.divIcon({
    className: "gs-map-marker",
    html: createGasStationMarkerHtml(status, isSelected),
    iconSize: [MARKER_OUTER_SIZE, MARKER_OUTER_SIZE],
    iconAnchor: [MARKER_ANCHOR, MARKER_ANCHOR],
  });
}
